import GoBack from "./_go-back";
import PageLoader from "./_page-loader";
import NumberCounter from "./_number-counter";
import Timeline from "./_timeline";
import RegionsMap from "./_regions-map";
import ModalListMyProperty from "./_modal-list-my-property";
import ModalContactUs from "./_modal-contact-us";
import MobileMainMenu from "./_mobile-main-menu";
import CustomFileInput from "./_custom-file-input";

const components = [
  {
    class: GoBack,
    selector: "#go-back",
    options: {},
  },
  {
    class: PageLoader,
    selector: "#preloader",
  },
  {
    class: NumberCounter,
    selector: ".number-counter",
  },
  {
    class: Timeline,
    selector: ".timeline-slider",
  },
  {
    class: RegionsMap,
    selector: ".home-region__map",
  },
  {
    class: ModalListMyProperty,
    selector: "#modal-list-my-property",
  },
  {
    class: ModalContactUs,
    selector: "#modal-contact-us",
  },
  {
    class: MobileMainMenu,
    selector: "#mobile-main-menu",
  },
  {
    class: CustomFileInput,
    selector: ".contact-form input[type=file]",
  },
];

components.forEach((component) => {
  if (document.querySelector(component.selector) !== null) {
    document
      .querySelectorAll(component.selector)
      .forEach((element) => new component.class(element, component.options));
  }
});
